import Module from '@/store/resource/common/module';
import Files from '@/store/resource/files';

let module = new Module(new Files());

export default module.create();
